<template>
  <thead>
    <tr class="trTotal">
      <th
        class="bordazIndex text-left text-dark"
        style="z-index: 3 !important">
        <div class="resGeralAling">
          <nobr>
            <span>
              <strong class="p-3" style="font-size: 12px">
                TOTAL
              </strong>
            </span>
          </nobr>
          <span
            class="text-right w-100 d-block pr-4">
            {{ totalVidas(cenarios) }}
          </span>
        </div>
      </th>
      <template v-for="(operadora, indexo) in cenarios[0].operadoras">
        <b-th
          class="alinharValores text-dark"
          v-for="(plano, p) in parsePlanos(operadora.grupos)"
          :key="`total-${indexo}-${plano.id}-${p}`">
          <span variant="link" class="shadow-none">
            {{ totalValor(plano, cenarios) | dinheiro }}
          </span>
        </b-th>
      </template>
    </tr>
  </thead>
</template>

<script>
import { mapActions, mapGetters } from "vuex"

export default {
  props: ['cenarios'],
  methods: {
    totalVidas(cenarios) {
      let vidas = 0
      cenarios.forEach(c => {
        vidas += c.faixas
          .map(f => Number(f.value) == "" ? 0 : Number(f.value))
          .reduce((o, c) => parseInt(o) + parseInt(c))
      })
      return vidas
    },
    totalValor(plano, cenarios) {
      let total = 0.00;
      cenarios.forEach(c => {
        c.operadoras.forEach(o => {
          o.grupos.forEach(g => {
            let p = g.planos.find(
              p => parseInt(p.key_operadora) == parseInt(plano.key_operadora)
               && parseInt(p.key_grupo) == parseInt(plano.key_grupo)
               && parseInt(p.key_plano) == parseInt(plano.key_plano)
               && p.modalidade == plano.modalidade
            )
            if (p) {
              total += p.filtros.regras_aceitacao && (p.alertas && p.alertas.length > 0)
                ? 0
                : p.taxas.iof == true ? parseFloat(p.calculo.total_iof) : parseFloat(p.calculo.total);
            }
          })
        })
      })
      return total
    },
    parsePlanos(grupos) {
      return grupos.reduce(function(prev, curr) {
        return [...prev, ...curr.planos];
      }, [])
    }
  }
}
</script>


<style lang="scss" scoped>
body {
  background-color: rgb(255, 255, 255) !important;
}
span {
  color: #4d5656;
  font-size: 9pt;
}
small {
  font-size: 8pt;
}
table {
  thead tr:first-child th {
    position: unset;
  }
  thead tr:nth-child(2) th {
    position: unset;
  }
  th {
    font-size: 10px !important;
    padding: 5px !important;
  }
  td {
    font-size: 10px !important;
    padding: 5px !important;
  }
}

div.info-plano-selecionado {
  display: inline-block;
  vertical-align: top;

  padding: 5px 8px;
  & h4 {
    margin: 0;
  }
  & h6 {
    font-weight: normal;
    margin-top: 4px;
  }
  & p {
    font-size: 12px;
    margin: 5px 0px;
  }
}

.card-logo {
  padding: 12px;
  color: #757575;
  border-radius: 5px;
  background-color: #fff;
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12),
    0 3px 1px -2px rgba(0, 0, 0, 0.2);
  width: 150px;
  height: 112.5px;
  margin: 10px;
  margin-bottom: 10px;
  text-align: center;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}
.logo img {
  width: 120px;
}
.infoCol {
  display: flex;
}
.impressao {
  h5 {
    border: 1px solid #ccc;
    padding: 5px;
  }
}
.carencias .card-body > div > div,
.docs .card-body > div > div,
.infos .card-body > div > div {
  padding: 5px;
}
.infos p {
  font-size: 12px;
}
/*
.redes, .reembolsos {
  overflow: hidden !important;
}
*/
@media only screen and (max-width: 700px) {
  div.logo-corretora {
    margin-left: 0 !important;
  }
  div.logo-corretora .card-logo,
  div.logo-operadora .card-logo {
    width: 125px;
  }
}
@media print {
  /* div.page .border {
    border: none;
  }
  h2,
  h3,
  h4 {
    page-break-before: always;
  }
  h5,
  h6 {
    page-break-after: avoid;
  }
  pre,
  blockquote {
    page-break-inside: avoid;
  } */
}

//Linha do Operado/Logo

.operadora > .logo {
  background-color: #fff;
  border-bottom: solid grey;
  height: 75px;
  padding: 0 10px 5px 10px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  flex-direction: column;
}
.operadora > .logo img {
  max-height: 100%;
  max-width: 120px;
}

//zebrada

table#table-group > thead > tr > th,
table#table-group > tbody > tr > th,
table#table-group > tfoot > tr > th,
table#table-group > thead > tr > td,
table#table-group > tbody > tr > td,
table#table-group > tfoot > tr > td {
  background-color: #fff;
}

table#table-group tr.alternate th,
table#table-group tr.alternate td {
  background-color: #f2f2f2;
  -webkit-print-color-adjust: exact;
  border-top: none;
  border-bottom: none;
}

.card-aviso p {
  color: #b92331;

  font-size: 12px;
  line-height: 1.4em;
}

//Alterações

.textChecked {
  display: none;
}
.custonCheck {
  display: flex;
  justify-content: center;
}

//Table 2

.resumoGeral {
  float: left;
  font-size: 1.1rem;
  font-weight: 400;
  margin: 0;
}

.resumoGeralTH {
  width: 900px !important;
}

.resGeralAling {
  display: flex;
  justify-content: space-between;
}

.alinharValores {
  text-align: center;
  color: #4d5656;
}

.bordazIndex {
  border-right: 1px solid #dee2e6 !important;
}

.plano_selecionado {
  background-color: #f3dc83 !important;
}
.plano_selecionado2 {
  background-color: #f3dc8388 !important;
}

.custom-control {
  z-index: 0;
}

.no-border {
  border: none;
}

.textColor {
  color: #4d5656;
}

.taxa_descricao {
  max-width: initial;
}
</style>
